import Grid from "@material-ui/core/Grid";
import { ViewStyled, TextStyled } from "./Graphic";
import Card from "./Card.component";
import { AssesmentInterface } from "../../../store/details/assessment/interface/AssesmentInterface";
import GridComponent from "../../../../component/grid/GridComponent.component";

interface GraphicInterface {
    title: string;
    qtdAssessments: number;
    valueNPS: number;
    answeredRatings: number;
}
  
export default function Rankings({ title, qtdAssessments, valueNPS, answeredRatings }: GraphicInterface) {

    return (
        <Grid item xs={12} sm={6}>
            <ViewStyled>
                <TextStyled>
                {title}
                </TextStyled>
                <GridComponent>
                    <Card title='Quantidade de Avaliações' ranking={qtdAssessments} />
                    <Card title='Avaliações respondidas' ranking={answeredRatings} />
                    <Card title='NPS do Mês' ranking={valueNPS} valuePaddingTitle='21px' />
                </GridComponent>
            </ViewStyled>
        </Grid>
    );
}
  